const ResourceTransChat = () =>
  import('@/views/main/inspect/resourceTransChat/ResourceTransChat.vue')
export default {
  path: '/main/inspect/resourceTransChat',
  name: 'ResourceTransChat',
  component: ResourceTransChat,
  children: []
}
